const resultFunction = (toAsset, form) => form.toAmount || toAsset.currency.ZERO;
const toAmountSelectorDefinition = {
    id: 'toAmount',
    resultFunction,
    dependencies: [{ selector: 'toAsset' }, { selector: 'form' }],
};
export default toAmountSelectorDefinition;
